import React, { createContext, useContext, useState, useEffect } from 'react';

const lightColors = {
  sageGreen: '#A8C3A0',
  deepForest: '#2F4632',
  warmCream: '#F7F4ED',
  softAmber: '#F2C98D',
  skyBlue: '#A7C7E7',
  white: '#FFFFFF',
  greyTrack: '#E8E8E8',
  greyText: 'rgba(47, 70, 50, 0.7)',
};

const darkColors = {
  sageGreen: '#A8C3A0',
  deepForest: '#E8EDE9',
  warmCream: '#1A1F1B',
  softAmber: '#F2C98D',
  skyBlue: '#A7C7E7',
  white: '#242B26',
  greyTrack: '#3A4340',
  greyText: 'rgba(232, 237, 233, 0.65)',
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('careskillset-theme');
    return saved === 'dark';
  });

  useEffect(() => {
    localStorage.setItem('careskillset-theme', isDark ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  const toggleTheme = () => setIsDark(prev => !prev);
  const colors = isDark ? darkColors : lightColors;

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) return { isDark: false, toggleTheme: () => {}, colors: lightColors };
  return ctx;
};
